module.exports = __webpack_public_path__ + "static/media/MHRM89N0002.9b18bee8.svg";